import moment from "moment";
import React, { useState, useEffect } from "react";

const style = {
    padding: "0.5rem",
    margin : "0 auto",
    display: 'block',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: '1.5rem',
    fontWeight: 'bold',
}

const Time = () => {
    const [dt, setDt] = useState(moment().format('ll , LTS'));

useEffect(() => {
    let secTimer = setInterval(() => {
        let date = moment().format('ll , LTS');
        setDt(date)
    }, 1000)

    return () => clearInterval(secTimer);
}, []);
    
    return (
        <div style={style}>
            <span>{dt}</span>
        </div>
    )
}

export default Time
